( () => {
    const RUN_KEY = "dwCustomInit";
    document.addEventListener("DOMContentLoaded", () => {
        const path = window.location.pathname;
        (path === "/" || path === "/pages/about-us") && document.body.classList.add("is-home")
    }
    ),
    document.addEventListener("DOMContentLoaded", () => {
        const header = document.querySelector("store-header.header");
        if (!header)
            return;
        const isMain = document.body.classList.contains("template-index")
          , isAbout = document.body.classList.contains("template-page") && window.location.pathname === "/pages/about-us"
          , isHowIt = document.body.classList.contains("template-page") && !!document.querySelector(".page-how-it");
        (isMain || isAbout || isHowIt) && header.classList.remove("is-filled")
    }
    );
    let impactSwiper = null
      , impactMode = null
      , impactResizeTimer = null
      , findReencleSwiper = null
      , findReencleMode = null
      , findReencleResizeTimer = null
      , hiwSwiper = null;
    function initImpactSwiper() {
        if (typeof Swiper > "u")
            return;
        const impactEl = document.querySelector(".impactSwiper");
        if (!impactEl)
            return;
        const isMobile = window.innerWidth < 768
          , nextMode = isMobile ? "mobile" : "pc";
        if (!(impactSwiper && impactMode === nextMode)) {
            if (impactMode = nextMode,
            impactSwiper) {
                try {
                    impactSwiper.destroy(!0, !0)
                } catch {}
                impactSwiper = null
            }
            impactSwiper = new Swiper(impactEl,{
                slidesPerView: isMobile ? 1.06 : 2,
                slidesPerGroup: isMobile ? 1 : 2,
                spaceBetween: isMobile ? 20 : 24,
                loop: !0,
                speed: 600,
                loopAdditionalSlides: 4,
                autoplay: {
                    delay: 3e3,
                    disableOnInteraction: !1
                },
                navigation: {
                    nextEl: impactEl.querySelector(".swiper-button-next"),
                    prevEl: impactEl.querySelector(".swiper-button-prev")
                },
                pagination: {
                    el: impactEl.closest(".real-impact-wr")?.querySelector(".swiper-pagination"),
                    clickable: !0
                }
            })
        }
    }
    function initFindReencleSwiper() {
        if (typeof Swiper > "u")
            return;
        const findEl = document.querySelector(".findReencleSwiper");
        if (!findEl)
            return;
        const section = findEl.closest(".find-reencle");
        const slideCount = findEl.querySelectorAll(".swiper-wrapper > .swiper-slide").length;
        const isMobile = window.innerWidth < 768;
        // Desktop: plain centered 3-column grid when there are 3 or fewer cards,
        // slider with arrows when there are more than 3. Mobile: always a slider.
        const nextMode = isMobile ? "mobile" : (slideCount > 3 ? "pc-slider" : "grid");
        if (findReencleMode === nextMode && (nextMode === "grid" || findReencleSwiper))
            return;
        findReencleMode = nextMode;
        if (findReencleSwiper) {
            try {
                findReencleSwiper.destroy(true, true)
            } catch {}
            findReencleSwiper = null
        }
        const paginationEl = section?.querySelector(".find-reencle__nav .swiper-pagination");
        const prevEl = section?.querySelector(".find-reencle__arrow--prev");
        const nextEl = section?.querySelector(".find-reencle__arrow--next");
        const showArrows = nextMode !== "grid" && slideCount > 3 && prevEl && nextEl;
        if (section) {
            section.classList.toggle("is-grid", nextMode === "grid");
            section.classList.toggle("has-arrows", !!showArrows);
        }
        if (nextMode === "grid")
            return;
        findReencleSwiper = new Swiper(findEl, {
            slidesPerView: isMobile ? 1.06 : 3,
            slidesPerGroup: 1,
            spaceBetween: isMobile ? 16 : 24,
            speed: 500,
            loop: false,
            watchOverflow: true,
            navigation: showArrows ? {
                prevEl: prevEl,
                nextEl: nextEl
            } : false,
            pagination: isMobile && paginationEl ? {
                el: paginationEl,
                clickable: true
            } : false
        });
    }
    function forceVideoSwiperLayout(swiper) {
        !swiper || swiper.destroyed || (requestAnimationFrame( () => {
            try {
                swiper.update(),
                swiper.updateSlides(),
                swiper.updateProgress(),
                swiper.updateSize(),
                swiper.slideToLoop(swiper.realIndex || 0, 0, !1)
            } catch {}
        }
        ),
        setTimeout( () => {
            if (!(!swiper || swiper.destroyed))
                try {
                    swiper.update(),
                    swiper.slideToLoop(swiper.realIndex || 0, 0, !1)
                } catch {}
        }
        , 80))
    }
    function initSwipers() {
        if (typeof Swiper > "u")
            return;
        const mainEl = document.querySelector(".mainSwiper");
        if (mainEl && !mainEl.dataset.dwInit) {
            mainEl.dataset.dwInit = "1";
            const mainSwiper = new Swiper(mainEl,{
                slidesPerView: 1,
                loop: !0,
                watchSlidesProgress: !0,
                pagination: {
                    el: ".tit-wr .swiper-pagination",
                    clickable: !0
                },
                speed: 650,
                autoplay: {
                    delay: 3e3,
                    disableOnInteraction: !1
                },
                threshold: 6,
                touchRatio: 1,
                followFinger: !0,
                resistanceRatio: .7,
                longSwipesRatio: .12,
                shortSwipes: !0,
                longSwipes: !0,
                preventClicks: !0,
                preventClicksPropagation: !0,
                on: {
                    touchStart(sw) {
                        sw.autoplay && sw.autoplay.stop()
                    },
                    touchEnd(sw) {
                        sw.autoplay && sw.autoplay.start()
                    },
                    transitionStart(sw) {
                        sw.allowTouchMove = !1
                    },
                    transitionEnd(sw) {
                        sw.allowTouchMove = !0
                    }
                }
            })
        }
        initImpactSwiper(),
        initFindReencleSwiper();
        const stepItems = document.querySelectorAll(".step-item")
          , listEl = document.querySelector(".listSwiper");
        if (listEl && stepItems.length && !listEl.dataset.dwInit) {
            listEl.dataset.dwInit = "1";
            const listSwiper = new Swiper(listEl,{
                slidesPerView: 1,
                speed: 600,
                loop: !0,
                autoplay: {
                    delay: 3e3,
                    disableOnInteraction: !1
                },
                pagination: {
                    el: listEl.closest(".slide-list")?.querySelector(".swiper-pagination"),
                    clickable: !0
                },
                on: {
                    init() {
                        const idx = this.realIndex;
                        stepItems.forEach(el => el.classList.remove("is-active")),
                        stepItems[idx]?.classList.add("is-active")
                    },
                    slideChange() {
                        const idx = this.realIndex;
                        stepItems.forEach(el => el.classList.remove("is-active")),
                        stepItems[idx]?.classList.add("is-active")
                    }
                }
            });
            stepItems.forEach(item => {
                item.dataset.dwBind || (item.dataset.dwBind = "1",
                item.addEventListener("click", () => {
                    const idx = Number(item.dataset.step);
                    Number.isFinite(idx) && (listSwiper.autoplay && listSwiper.autoplay.stop(),
                    listSwiper.slideToLoop(idx, 600))
                }
                ))
            }
            )
        }
        const videoSwiperEl = document.querySelector(".videoSwiper")
          , container = document.querySelector(".ct-video");
        if (videoSwiperEl && container && !videoSwiperEl.dataset.dwInit) {
            let updateDots2 = function(swiper) {
                if (!pagEl)
                    return;
                const dots = pagEl.querySelectorAll(".dot")
                  , idx = (swiper.realIndex % totalDots + totalDots) % totalDots;
                dots.forEach(d => d.classList.toggle("is-active", Number(d.dataset.dot) === idx))
            }
              , getActiveItem2 = function(swiper) {
                const activeSlide = swiper.slides[swiper.activeIndex];
                return activeSlide?.classList?.contains("ct-vi") ? activeSlide : activeSlide?.querySelector?.(".ct-vi")
            }
              , setInitialActive2 = function(item) {
                items.forEach(it => {
                    it.classList.remove("on"),
                    it.dataset.sound = "0";
                    const v = it.querySelector("video");
                    v && (v.muted = !0)
                }
                ),
                item.classList.add("on"),
                item.dataset.sound = "0"
            }
              , setActiveWithSound2 = function(item) {
                items.forEach(it => {
                    it.classList.remove("on"),
                    it.dataset.sound = "0";
                    const vv = it.querySelector("video");
                    vv && (vv.muted = !0)
                }
                ),
                item.classList.add("on"),
                item.dataset.sound = "1";
                const v = item.querySelector("video");
                if (!v)
                    return;
                try {
                    v.currentTime = 0
                } catch {}
                v.muted = !1;
                const p = v.play();
                p && typeof p.catch == "function" && p.catch( () => {}
                )
            }
              , setOff2 = function(item) {
                item.classList.remove("on"),
                item.dataset.sound = "0";
                const v = item.querySelector("video");
                v && (v.muted = !0)
            };
            var updateDots = updateDots2
              , getActiveItem = getActiveItem2
              , setInitialActive = setInitialActive2
              , setActiveWithSound = setActiveWithSound2
              , setOff = setOff2;
            videoSwiperEl.dataset.dwInit = "1";
            const items = Array.from(container.querySelectorAll(".ct-vi"))
              , videos = items.map(it => it.querySelector("video")).filter(Boolean)
              , videoSwiper = new Swiper(".videoSwiper",{
                speed: 600,
                slidesPerView: 1,
                spaceBetween: 20,
                loop: !0,
                allowTouchMove: !0,
                pagination: {
                    el: ".videoSwiper .swiper-pagination",
                    clickable: !0
                },
                breakpoints: {
                    1199: {
                        slidesPerView: 3,
                        spaceBetween: 24,
                        allowTouchMove: !1,
                        autoplay: !1
                    },
                    768: {
                        slidesPerView: 3,
                        spaceBetween: 14,
                        allowTouchMove: !1,
                        autoplay: !1
                    }
                }
            })
              , totalDots = 3
              , pagEl = container.querySelector(".video-pagination-3");
            pagEl && !pagEl.dataset.dwInit && (pagEl.dataset.dwInit = "1",
            pagEl.innerHTML = Array.from({
                length: totalDots
            }).map( (_, i) => `<button type="button" class="dot" data-dot="${i}" aria-label="Go to slide ${i + 1}"></button>`).join("")),
            pagEl?.addEventListener("click", e => {
                const btn = e.target.closest(".dot");
                if (!btn)
                    return;
                const target = Number(btn.dataset.dot);
                if (!Number.isFinite(target))
                    return;
                const current = videoSwiper.realIndex
                  , candidates = [target, target + 3]
                  , nearest = candidates.reduce( (best, c) => Math.abs(c - current) < Math.abs(best - current) ? c : best, candidates[0]);
                videoSwiper.slideToLoop(nearest, 600)
            }
            ),
            videoSwiper.on("init", () => updateDots2(videoSwiper)),
            videoSwiper.on("slideChange", () => updateDots2(videoSwiper)),
            updateDots2(videoSwiper),
            videos.forEach(v => {
                v.muted = !0,
                v.loop = !0;
                const p = v.play();
                p && typeof p.catch == "function" && p.catch( () => {}
                )
            }
            ),
            requestAnimationFrame( () => {
                const firstItem = getActiveItem2(videoSwiper);
                firstItem && setInitialActive2(firstItem)
            }
            ),
            container.dataset.dwBindClick || (container.dataset.dwBindClick = "1",
            container.addEventListener("click", e => {
                const item = e.target.closest(".ct-vi");
                if (!item)
                    return;
                if (!!e.target.closest(".btn-sound")) {
                    const v = item.querySelector("video");
                    if (!v)
                        return;
                    if (item.dataset.sound === "1") {
                        item.dataset.sound = "0",
                        v.muted = !0;
                        return
                    }
                    items.forEach(it => {
                        it.dataset.sound = "0";
                        const vv = it.querySelector("video");
                        vv && (vv.muted = !0)
                    }
                    ),
                    item.dataset.sound = "1",
                    v.muted = !1;
                    const p = v.play();
                    p && typeof p.catch == "function" && p.catch( () => {}
                    );
                    return
                }
                if (item.classList.contains("on") && item.dataset.sound !== "1") {
                    setActiveWithSound2(item);
                    return
                }
                if (item.classList.contains("on") && item.dataset.sound === "1") {
                    setOff2(item);
                    return
                }
                setActiveWithSound2(item)
            }
            )),
            videoSwiper.on("slideChange", function() {
                const item = getActiveItem2(this);
                item && setInitialActive2(item)
            }),
            videos.forEach(v => {
                v.addEventListener("loadedmetadata", () => forceVideoSwiperLayout(videoSwiper), {
                    once: !0
                }),
                v.addEventListener("canplay", () => forceVideoSwiperLayout(videoSwiper), {
                    once: !0
                })
            }
            ),
            window.addEventListener("load", () => forceVideoSwiperLayout(videoSwiper)),
            document.addEventListener("shopify:section:load", () => forceVideoSwiperLayout(videoSwiper))
        }
    }
    function initToggle() {
        document.querySelectorAll(".vs-bx .list-btn").forEach(btn => {
            btn.dataset.dwBind || (btn.dataset.dwBind = "1",
            btn.addEventListener("click", e => {
                e.preventDefault();
                const box = btn.closest(".vs-bx");
                box && box.classList.toggle("off")
            }
            ))
        }
        )
    }
    function initTopButton() {
        if (window.jQuery) {
            if (jQuery(".btn-top").data("dwBind"))
                return;
            jQuery(".btn-top").data("dwBind", 1).on("click", function() {
                return jQuery("html, body").animate({
                    scrollTop: 0
                }, 800),
                !1
            });
            return
        }
        document.querySelectorAll(".btn-top").forEach(btn => {
            btn.dataset.dwBind || (btn.dataset.dwBind = "1",
            btn.addEventListener("click", e => {
                e.preventDefault(),
                window.scrollTo({
                    top: 0,
                    behavior: "smooth"
                })
            }
            ))
        }
        )
    }
    function initAboutScroll() {
        if (typeof gsap > "u" || typeof ScrollTrigger > "u")
            return;
        gsap.registerPlugin(ScrollTrigger);
        const section = document.querySelector(".page-about .main-scroll-section");
        if (!section || section.dataset.dwAboutInit)
            return;
        section.dataset.dwAboutInit = "1";
        const slide01 = section.querySelector(".slide01")
          , slide02 = section.querySelector(".slide02")
          , slide03 = section.querySelector(".slide03");
        if (!slide01 && !slide02)
            return;
        function escAttr(str) {
            return String(str).replace(/"/g, "&quot;")
        }
        function makePanelHTML(slide, prefix, darkBg, layerCls) {
            const textWrap = slide.querySelector(".text-wrap")
              , textInner = textWrap ? textWrap.innerHTML : ""
              , imgsHTML = Array.from(slide.querySelectorAll(".scroll-bg img")).map( (img, i) => {
                const src = img.getAttribute("src") || ""
                  , alt = img.getAttribute("alt") || ""
                  , mergedClass = ((img.getAttribute("class") || "") + " " + prefix + "-img-" + i).trim();
                return '<img src="' + escAttr(src) + '" alt="' + escAttr(alt) + '" class="' + escAttr(mergedClass) + '">'
            }
            ).join("");
            return '<div class="scroll-text-layer' + (darkBg ? " dark" : "") + '"><div class="text-wrap main-title">' + textInner + '</div></div><div class="scroll-img-layer' + (layerCls ? " " + layerCls : "") + '">' + imgsHTML + "</div>"
        }
        const p1 = document.createElement("div");
        p1.className = "scroll-panel panel-01",
        slide01 && (p1.innerHTML = makePanelHTML(slide01, "p1", !0, ""));
        const p2 = document.createElement("div");
        p2.className = "scroll-panel panel-02",
        slide02 && (p2.innerHTML = makePanelHTML(slide02, "p2", !1, "scroll-img-layer--white"));
        let p3 = null;
        slide03 && (p3 = document.createElement("div"),
        p3.className = "scroll-panel panel-03",
        p3.innerHTML = makePanelHTML(slide03, "p3", !1, "")),
        section.innerHTML = "",
        section.appendChild(p1),
        section.appendChild(p2),
        p3 && section.appendChild(p3);
        const s1Text = p1.querySelector(".text-wrap")
          , s1Img0 = p1.querySelector(".p1-img-0")
          , s1Img1 = p1.querySelector(".p1-img-1")
          , s2Text = p2.querySelector(".text-wrap")
          , s2Img = p2.querySelector(".p2-img-0");
        if (s1Text && gsap.set(s1Text, {
            opacity: .2
        }),
        s1Img1 && gsap.set(s1Img1, {
            opacity: 0
        }),
        gsap.set(p2, {
            autoAlpha: 0
        }),
        s2Text && gsap.set(s2Text, {
            opacity: .2
        }),
        s2Img && gsap.set(s2Img, {
            opacity: 0
        }),
        p3) {
            gsap.set(p3, {
                autoAlpha: 0
            });
            const s3Text = p3.querySelector(".text-wrap");
            s3Text && gsap.set(s3Text, {
                opacity: .2
            })
        }
        const mouseEl = document.querySelector(".page-about .mouse")
          , mouseArea = document.querySelector(".page-about .mouse-area");
        window.innerWidth < 768 && (section.style.height = "calc(100vh - 72px)");
        const totalDur = p3 ? 15 : 11
          , tl = gsap.timeline({
            scrollTrigger: {
                trigger: section,
                start: window.innerWidth < 768 ? "top 72px" : "top top",
                end: () => "+=" + window.innerHeight * (p3 ? 6 : 4),
                pin: !0,
                scrub: .6,
                anticipatePin: 1,
                onLeave: function() {
                    mouseArea && (mouseArea.style.opacity = "0",
                    mouseArea.style.visibility = "hidden")
                },
                onEnterBack: function() {
                    mouseArea && (mouseArea.style.opacity = "1",
                    mouseArea.style.visibility = "visible")
                },
                onUpdate: function(self) {
                    if (mouseEl) {
                        var pos = self.progress * totalDur;
                        pos >= 5 && pos <= 11 ? mouseArea && mouseArea.classList.add("mouse--dark") : mouseArea && mouseArea.classList.remove("mouse--dark")
                    }
                }
            }
        });
        if (s1Text && tl.to(s1Text, {
            opacity: 1,
            duration: 4.5,
            ease: "none"
        }, 0),
        s1Img0 && s1Img1 && tl.to(s1Img0, {
            opacity: 0,
            duration: 2.5,
            ease: "none"
        }, 1).to(s1Img1, {
            opacity: 1,
            duration: 2.5,
            ease: "none"
        }, 1),
        tl.to(p1, {
            autoAlpha: 0,
            duration: 1,
            ease: "none"
        }, 5).to(p2, {
            autoAlpha: 1,
            duration: 1,
            ease: "none"
        }, 5),
        s2Text && tl.to(s2Text, {
            opacity: 1,
            duration: 4.5,
            ease: "none"
        }, 6),
        s2Img && tl.to(s2Img, {
            opacity: 1,
            duration: 2,
            ease: "none"
        }, 8),
        p3) {
            const s3Text = p3.querySelector(".text-wrap");
            tl.to(p2, {
                autoAlpha: 0,
                duration: 1,
                ease: "none"
            }, 11).to(p3, {
                autoAlpha: 1,
                duration: 1,
                ease: "none"
            }, 11),
            s3Text && tl.to(s3Text, {
                opacity: 1,
                duration: 3,
                ease: "none"
            }, 12)
        }
    }
    function initWasteReveal() {
        const items = document.querySelectorAll(".page-about .fade-up:not(.reencle-section .fade-up)");
        if (!items.length)
            return;
        const observer = new IntersectionObserver(entries => {
            entries.forEach(entry => {
                entry.isIntersecting && (entry.target.classList.add("is-visible"),
                observer.unobserve(entry.target))
            }
            )
        }
        ,{
            threshold: .15,
            rootMargin: "0px 0px -40px 0px"
        });
        items.forEach(el => observer.observe(el))
    }
    function initDiffScrub() {
        if (typeof gsap > "u" || typeof ScrollTrigger > "u")
            return;
        gsap.registerPlugin(ScrollTrigger);
        const section = document.querySelector(".page-about .reencle-section");
        if (!section || section.dataset.dwDiffInit)
            return;
        section.dataset.dwDiffInit = "1";
        const fadeEls = gsap.utils.toArray(section.querySelectorAll(".fade-up"));
        if (!fadeEls.length)
            return;
        const isMo = window.innerWidth < 768
          , startPos = isMo ? "98%" : "85%"
          , endPos = isMo ? "75%" : "50%"
          , staggerGap = isMo ? 40 : 80;
        fadeEls.forEach(el => {
            let sibIdx = 0
              , prev = el.previousElementSibling;
            for (; prev; )
                prev.classList.contains("fade-up") && sibIdx++,
                prev = prev.previousElementSibling;
            const offset = sibIdx * staggerGap;
            gsap.fromTo(el, {
                opacity: 0,
                y: isMo ? 30 : 50
            }, {
                opacity: 1,
                y: 0,
                ease: "none",
                scrollTrigger: {
                    trigger: el,
                    scrub: 1,
                    start: "top+=" + offset + " " + startPos,
                    end: "top+=" + offset + " " + endPos,
                    invalidateOnRefresh: !0
                }
            })
        }
        )
    }
    function initStatCounter() {
        const stats = document.querySelectorAll(".stat-num");
        stats.length && stats.forEach(el => {
            const start = parseFloat(el.dataset.start) || 0
              , end = parseFloat(el.dataset.end) || 0
              , suffix = el.dataset.suffix || ""
              , hasDecimal = end % 1 !== 0;
            let obj = {
                value: start
            };
            gsap.to(obj, {
                value: end,
                duration: 1.2,
                ease: "power2.out",
                scrollTrigger: {
                    trigger: el.closest(".waste-impact-section"),
                    start: "top 80%",
                    toggleActions: "play none none none"
                },
                onUpdate: function() {
                    el.textContent = (hasDecimal ? obj.value.toFixed(1) : Math.floor(obj.value)) + suffix
                }
            })
        }
        )
    }
    function initHowItProcessSwiper() {
        if (typeof Swiper > "u")
            return;
        const el = document.querySelector(".page-how-it .hiw-process-swiper");
        if (el) {
            if (window.innerWidth >= 768) {
                hiwSwiper && (hiwSwiper.destroy(!0, !0),
                hiwSwiper = null);
                return
            }
            hiwSwiper || (hiwSwiper = new Swiper(el,{
                slidesPerView: 1,
                loop: !1,
                pagination: {
                    el: el.querySelector(".swiper-pagination"),
                    clickable: !0
                }
            }))
        }
    }
    function initHowItFitCart() {
        const btns = document.querySelectorAll(".page-how-it .hiw-fit-btn");
        btns.length && btns.forEach(btn => {
            btn.dataset.dwFitCart || (btn.dataset.dwFitCart = "1",
            btn.addEventListener("click", () => {
                const variantId = btn.dataset.variantId;
                if (!variantId)
                    return;
                btn.disabled = !0;
                const origLabel = btn.textContent;
                btn.textContent = "Adding...",
                fetch("/cart/add.js", {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json"
                    },
                    body: JSON.stringify({
                        id: variantId,
                        quantity: 1
                    })
                }).then(res => {
                    if (!res.ok)
                        throw new Error("cart/add failed");
                    return res.json()
                }
                ).then(item => {
                    btn.textContent = "Added!",
                    document.dispatchEvent(new CustomEvent("variant:add",{
                        detail: {
                            variant: item
                        }
                    })),
                    document.dispatchEvent(new CustomEvent("cart:refresh"))
                }
                ).catch( () => {
                    btn.textContent = "Error"
                }
                ).finally( () => {
                    setTimeout( () => {
                        btn.textContent = origLabel,
                        btn.disabled = !1
                    }
                    , 2e3)
                }
                )
            }
            ))
        }
        )
    }
    function initHowItScrollIndicator() {
        const indicator = document.querySelector(".page-how-it .hiw-scroll-indicator");
        if (!indicator)
            return;
        function checkVisible() {
            if (window.innerWidth >= 1200) {
                const sec4 = document.querySelector(".page-how-it .hiw-process-section");
                let show = !1;
                if (sec4) {
                    const r = sec4.getBoundingClientRect();
                    show = r.top < window.innerHeight && r.bottom > 0
                }
                indicator.style.opacity = show ? "1" : "0",
                indicator.style.visibility = show ? "visible" : "hidden";
                return
            }
            window.scrollY + window.innerHeight >= document.documentElement.scrollHeight - 160 ? (indicator.style.opacity = "0",
            indicator.style.visibility = "hidden") : (indicator.style.opacity = "1",
            indicator.style.visibility = "visible")
        }
        window.addEventListener("scroll", checkVisible, {
            passive: !0
        }),
        window.addEventListener("resize", checkVisible, {
            passive: !0
        }),
        checkVisible()
    }
    function initHowItProcess() {
        if (typeof gsap > "u" || typeof ScrollTrigger > "u" || window.innerWidth < 768)
            return;
        gsap.registerPlugin(ScrollTrigger);
        const wrap = document.querySelector(".page-how-it .hiw-process-sticky-wrap");
        if (!wrap || wrap.dataset.dwProcInit)
            return;
        const panels = Array.from(wrap.querySelectorAll(".hiw-process-panel"));
        if (panels.length < 2)
            return;
        wrap.dataset.dwProcInit = "1",
        gsap.set(panels, {
            autoAlpha: 0
        }),
        gsap.set(panels[0], {
            autoAlpha: 1
        });
        const FADE = .9
          , HOLD = 1.1
          , STEP = FADE + HOLD
          , tl = gsap.timeline({
            scrollTrigger: {
                trigger: wrap,
                start: "top top",
                end: () => "+=" + window.innerHeight * panels.length * 1.4,
                pin: !0,
                scrub: .8,
                anticipatePin: 1
            }
        });
        for (let i = 1; i < panels.length; i++) {
            const pos = HOLD + (i - 1) * STEP;
            tl.to(panels[i - 1], {
                autoAlpha: 0,
                duration: FADE,
                ease: "none"
            }, pos).fromTo(panels[i], {
                autoAlpha: 0,
                y: 24
            }, {
                autoAlpha: 1,
                y: 0,
                duration: FADE,
                ease: "none"
            }, pos)
        }
    }
    function initAll() {
        document.documentElement.dataset[RUN_KEY] || (document.documentElement.dataset[RUN_KEY] = "1"),
        initSwipers(),
        initAboutScroll(),
        initWasteReveal(),
        initDiffScrub(),
        initStatCounter(),
        initHowItProcessSwiper(),
        initHowItProcess(),
        initHowItFitCart(),
        initHowItScrollIndicator(),
        initToggle(),
        initTopButton()
    }
    document.addEventListener("DOMContentLoaded", initAll),
    document.addEventListener("shopify:section:load", initAll),
    window.addEventListener("resize", () => {
        clearTimeout(impactResizeTimer),
        impactResizeTimer = setTimeout( () => {
            initImpactSwiper(),
            initHowItProcessSwiper()
        }
        , 200),
        clearTimeout(findReencleResizeTimer),
        findReencleResizeTimer = setTimeout(initFindReencleSwiper, 200)
    }
    )
}
)();
//# sourceMappingURL=/cdn/shop/t/33/assets/custom.js.map?v=42851900427588724211783302818